import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpUtils } from '@smooved/core';
import { StringUtils } from '@core/utils';
import { WaterSupplier } from '@ui/water/interfaces/water-supplier';
import { Observable } from 'rxjs';
import {
    baseUri,
    baseUriActive,
    baseUriAttachments,
    baseUriSubmit,
    baseUriGenerateWaterTransferDocument,
    suppliersUri,
} from '../constants/uri.constants';
import { WaterTransferDocumentServiceDto, WaterServiceRequest } from '../types/water-transfer-document-service-dto';
import { WaterTransferAssetType } from '@ui/water/enums/water-transfer-asset-type.enum';

@Injectable({
    providedIn: 'root',
})
export class WaterTransferDocumentServiceService {
    private readonly httpClient = inject(HttpClient);

    public getWaterService(transactionId: string): Observable<WaterTransferDocumentServiceDto> {
        return this.httpClient.get<WaterTransferDocumentServiceDto>(StringUtils.parseUri(baseUri, { transactionId }));
    }

    public patchWaterService(transactionId: string, payload: WaterServiceRequest): Observable<WaterTransferDocumentServiceDto> {
        return this.httpClient.patch<WaterTransferDocumentServiceDto>(StringUtils.parseUri(baseUri, { transactionId }), payload);
    }

    public getWaterSuppliers(): Observable<WaterSupplier[]> {
        return this.httpClient.get<WaterSupplier[]>(suppliersUri);
    }

    public setActive(transactionId: string, active: boolean): Observable<WaterTransferDocumentServiceDto> {
        return this.httpClient.patch<WaterTransferDocumentServiceDto>(StringUtils.parseUri(baseUriActive, { transactionId }), {
            value: active,
        });
    }

    public submitWaterService(transactionId: string, submit: boolean): Observable<WaterTransferDocumentServiceDto> {
        return this.httpClient.patch<WaterTransferDocumentServiceDto>(StringUtils.parseUri(baseUriSubmit, { transactionId }), {
            value: submit,
        });
    }

    public updateWaterTransferAssets(
        transactionId: string,
        assetKeysToRemove: string[],
        files: File[],
        waterTransferAssetType?: WaterTransferAssetType,
    ): Observable<WaterTransferDocumentServiceDto> {
        const formData = new FormData();

        files.forEach((file) => {
            formData.append('files', file);
        });

        formData.append('assetKeysToRemove', assetKeysToRemove.join(';'));

        return this.httpClient.post<WaterTransferDocumentServiceDto>(
            StringUtils.parseUri(baseUriAttachments, { transactionId }),
            formData,
            {
                params: HttpUtils.buildQueryParameters({ waterTransferAssetType }),
            },
        );
    }

    public generateWaterTransferDocument(transactionId: string): Observable<WaterTransferDocumentServiceDto> {
        return this.httpClient.post<WaterTransferDocumentServiceDto>(
            StringUtils.parseUri(baseUriGenerateWaterTransferDocument, { transactionId }),
            {},
        );
    }
}
